import { get } from '@aiptyg/api-client';
import type { NewcomerRewardListResponseDTO } from './types';

export interface NewcomerRewardListParams {
  page: number;
  pageSize: number;
  userId: string;
  status: string;
  range: string;
}

export function listNewcomerRewards(params: NewcomerRewardListParams): Promise<NewcomerRewardListResponseDTO> {
  const qs = new URLSearchParams();
  qs.set('page', String(params.page));
  qs.set('page_size', String(params.pageSize));
  if (params.userId) qs.set('user_id', params.userId);
  if (params.status) qs.set('status', params.status);
  if (params.range) qs.set('range', params.range);
  return get<NewcomerRewardListResponseDTO>(`/v1/admin/newcomer-rewards?${qs.toString()}`);
}
